import getHelper from '../../../services/getHelper';

type Signatory = {
  id: number;
  displayName: string;
  firstName: string;
  lastName: string;
  positionTitle: string;
  signatureUrl: string;
};

export default getHelper<Signatory>('/signatories/:id');
